import React from 'react';
import { RightSidebar } from "../../../_partials/Layout";
import Sortable from "src/componets/Sortable";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { reorderServerPlans } from "src/actions/mine_craft/serverPlansActions";
import usePermissions from "src/hooks/usePermissions";

const _SidebarIndex = () => {
  const dispatch   = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.serverPlans.ids);
  const plans      = useAppSelector(state => state.mineCraft.serverPlans.entities);
  const { write_minecraft } = usePermissions();

  function onClickSave(ids: any[]) {
    dispatch(reorderServerPlans({ ids }));
  }

  if (!write_minecraft) {
    return null;
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>

      <hr className="v-divider" />

      <h6 className="v-content-label o-sm">Reorder Plans</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            items={plans}
            titleKey='title'
          />
      }
    </RightSidebar>
  )
}

export default _SidebarIndex;
